import { render, staticRenderFns } from "./CrmSectionSettings.vue?vue&type=template&id=62636540&scoped=true&"
import script from "./CrmSectionSettings.vue?vue&type=script&lang=js&"
export * from "./CrmSectionSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62636540",
  null
  
)

export default component.exports